import React from "react";
import SuccessIcon from "@atlaskit/icon/glyph/check-circle";
import ErrorIcon from "@atlaskit/icon/glyph/error";
import {token} from "@atlaskit/tokens";
import {G400} from "@atlaskit/theme/colors";
import {AppearanceTypes, CreateFlagArgs} from "@atlaskit/flag";
import WarningIcon from "@atlaskit/icon/glyph/warning";

export const successFlag = (args: Partial<CreateFlagArgs>): CreateFlagArgs => {
    return {
        appearance: "normal" as AppearanceTypes,
        isAutoDismiss: true,
        title: "Success",
        icon: (<SuccessIcon label="Success" primaryColor={token("color.border.success", G400)}/>),
        ...args,
    }
};

export const errorFlag = (args: Partial<CreateFlagArgs>): CreateFlagArgs => {
    return {
        appearance: "normal" as AppearanceTypes,
        isAutoDismiss: false,
        title: "Error",
        icon: (<ErrorIcon label="Error" primaryColor={token("color.border.danger", G400)}/>),
        ...args,
    }
};

export const warnFlag = (args: Partial<CreateFlagArgs>): CreateFlagArgs => {
    return {
        appearance: "warning" as AppearanceTypes,
        isAutoDismiss: true,
        title: "Warning",
        icon: (<WarningIcon label="Warning" primaryColor={token("color.border.warning", G400)}/>),
        ...args,
    }
};
